import { Component, Inject, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { UploadDialog } from '../upload-dailog.component';

@Component({
  selector: 'app-chatbot-flow',
  templateUrl: './chatbot-flow.component.html',
  styleUrls: ['./chatbot-flow.component.css'],
})
export class ChatbotFlowComponent implements OnInit {
  loaded = false;

  buttonClicked = false;
  success = false;
  status;

  chatbot = {
    client: null as any,
    type: null as any,
    xl: null as any,
    zip: null as any,
  };

  clients = JSON.parse(sessionStorage.getItem('clients'));
  chatbotTypes = JSON.parse(sessionStorage.getItem('chatbotTypes'));
  resp = [] as any; 

  constructor(
    private api: ApiService,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    private jwt: JwtService,
    private mixpanel: MixpanelService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.mixpanel.track('page_view', {
      page: 'Chatbot',
      category: 'Dashboard',
      button: '-',
    });
    this.jwt.check();
  }

  upload(status: boolean) {
    this.status = status;
    const formData = new FormData();
    formData.append('chatbotType', this.chatbot.type);
    formData.append('client', this.chatbot.client);
    formData.append('excelFile', this.chatbot.xl);
    if (this.chatbot.zip) {
      formData.append('zipFile', this.chatbot.zip);
    }
    if (status) {
      const dialogRef = this.dialog.open(UploadDialog);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.buttonClicked = true;
          this.mixpanel.track('button_click', {
            page: 'Micro Learning',
            category: 'Dashboard',
            button: 'Upload',
          });
          formData.append('commit', 'yes');
          this.apiCall(formData);
        } else {
          //pass
        }
      });
    } else {
      this.buttonClicked = true;
      this.mixpanel.track('button_click', {
        page: 'Micro Learning',
        category: 'Dashboard',
        button: 'Verify',
      });
      this.apiCall(formData);
    }
  }

  apiCall(formData) {
    this.api.chatbot(formData).subscribe(
      (data: any) => {
        this.buttonClicked = false;
        this.success = true;
        if (data.data.length > 0) {
          this.resp = this.sanitizer.bypassSecurityTrustHtml(
            data.data.join('')
          );
        } else {
          this.resp = null;
        }
        this.response(false);
        if (data.status) {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'success',
          });
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
        }
      },
      (error) => {
        this.buttonClicked = false;
      }
    );
  }

  remove() {
    this.chatbot.xl = null;
  }

  onFileSelected(event: any): void {
    this.chatbot.xl = event.target.files[0] ?? null;
  }

  remove1() {
    this.chatbot.zip = null;
  }

  onFileSelected1(event: any): void {
    this.chatbot.zip = event.target.files[0] ?? null;
  }

  response(status) {
    if (status) {
      this.mixpanel.track('button_click', {
        page: 'Chatbot',
        category: 'Dashboard',
        button: 'View Log',
      });
    }
    if (this.resp != null) {
      this._bottomSheet.open(ChatbotResponse, { data: this.resp });
    }
  }
}

@Component({
  selector: 'chatbot-response',
  templateUrl: './chatbot-response.html',
})
export class ChatbotResponse {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<ChatbotFlowComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: []
  ) {}
}
